import ActionsMenu from './ActionsMenu';
import ActionsMenuContainer from './ActionsMenu.container';
export default ActionsMenuContainer(ActionsMenu);
